import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import { installErrorReporting } from './lib/errors.ts';
import { installSignals } from './lib/signals.ts';
import './styles/index.css';

installErrorReporting();
installSignals();

// Na een release bestaat een stuk code van de oude versie (chunk) niet meer op de server: dan de pagina
// één keer opnieuw laden in plaats van een scherm dat niet opent; niet vaker dan eens per minuut.
window.addEventListener('vite:preloadError', (e) => {
  const key = 'jerome-herlaad';
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(key) ?? 0);
    sessionStorage.setItem(key, String(Date.now()));
  } catch {
    // geen opslag: dan hooguit herladen zonder rem
  }
  if (Date.now() - last < 60_000) return;
  e.preventDefault();
  location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
